<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  }),
  mounted() {
    // Legacy deep-links used `?signin=1` to open the sign-in popup; the flow is
    // now a routed page, so forward those links to /login.
    this.maybeRedirectSignin();
  },
  watch: {
    '$route.query.signin'() {
      this.maybeRedirectSignin();
    },
  },
  methods: {
    maybeRedirectSignin() {
      if (String(this.$route.query.signin) !== '1') return;
      const token = (localStorage.getItem('token') || '').trim();
      // Strip the flag so a refresh / back-nav does not re-trigger this.
      const query = { ...this.$route.query };
      delete query.signin;
      this.$router.replace({ query }).catch(() => {});
      if (!token) {
        this.$router.push('/login').catch(() => {});
      }
    },
  },
};
</script>
<style>
@import "./app-css/style.css";
*{
  scroll-behavior: smooth;
}
</style>